import { TBrandLabel } from '../../../../redux/userProfile/types';
import { TCustomLabelsInitialState } from '../../../../redux/settings/types';

export const prepareCustomLabelsList = (
  brand?: string,
  newLabels?: TBrandLabel[],
  customLabels?: TCustomLabelsInitialState[]
): TCustomLabelsInitialState[] | undefined => {
  if (!customLabels) return [];
  if (!brand) return customLabels;
  const dataWithoutCurrentIBrand = customLabels?.filter((item) => {
    const key = Object.keys(item)[0];
    const id = Number(key);
    return id !== Number(brand);
  });

  const isEmptyArray = !Array.isArray(newLabels) || newLabels.length === 0;
  if (isEmptyArray) {
    return dataWithoutCurrentIBrand;
  }
  const newItem = { [brand]: newLabels };

  return [...(dataWithoutCurrentIBrand ?? []), newItem];
};
